import styled from 'styled-components';

export const Card = styled.div`
  border-color: ${(props) => props.theme.$gray400};
  border-radius: 8px;

  th,
  td {
    padding: 1rem 1.5rem;
    vertical-align: middle;
  }

  thead th {
    border-top: 0;
    border-bottom: 1px solid ${(props) => props.theme.$gray400};
  }

  .company-cell {
    min-width: 220px;
  }
`;
